<template>
    <default-modal
        ref="box"
        :title="title"
        :modalWidth="600"
        :confirmTxt="confirmText"
        @confirm="confirm"
    >
        <div class="modal-body">
            <div class="tips">
                <div>
                    <span style="font-weight:700;">「环境信息」</span
                    >类似于网吧软件环境标签，帮助你更加简单的了解网吧环境。
                </div>
                <div>
                    如果系统环境信息自动检测有误，你可以自行标记系统环境信息。
                </div>
                <div>
                    当手动指定环境之后，系统将不再自动检测环境信息。
                </div>
            </div>
            <div class="table">
                <div class="table-header row">
                    <div>
                        软件类型
                    </div>
                    <div>
                        检测模式
                    </div>
                </div>
                <div class="table-body">
                    <div
                        class="row"
                        v-for="(item, index) in tableList"
                        :key="index"
                    >
                        <!-- 软件类型 -->
                        <div>
                            <span v-text="item.label"></span>
                        </div>
                        <!-- 检测模式 -->
                        <div>
                            <select v-model="item.value">
                                <option
                                    v-for="(it, ind) in item.children"
                                    :key="ind"
                                    v-text="it.label"
                                    :value="it.value"
                                ></option>
                            </select>
                        </div>
                    </div>
                    <no-data
                        style="height:auto;padding-top:20px;padding-bottom:20px;"
                        v-show="tableList.length == 0 || loading"
                        :nodata="tableList.length == 0 && !loading"
                        :loading="loading"
                    ></no-data>
                </div>
            </div>
        </div>
    </default-modal>
</template>
<script>
import DefaultModal from "_c/modals/defaultModal";
import NoData from "_c/noData/noData";
import { listEvnInfo, environmentSettings } from "@/requests/securityCenter";
export default {
    components: {
        DefaultModal,
        NoData
    },
    data() {
        return {
            title: "设置环境",
            successFn: "",
            barId: "",
            confirmText: "保存",
            tableList: [],
            arr: [],
            centerItem: "",
            val: 0,
            loading: false
        };
    },
    mounted() {
        window.$modal.environmentSettings = {};
        window.$modal.environmentSettings.show = (id, val) => {
            this.barId = id;
            this.val = val;
            this.getList();
            return new Promise(resolve => {
                this.init(() => {
                    resolve(true);
                });
            });
        };
    },
    methods: {
        // 初始化信息
        init(fn) {
            this.$refs.box.show();
            this.successFn = fn;
        },
        async getList() {
            this.loading = true;
            let resValue = await listEvnInfo({
                barId: this.val === 1 ? "" : this.barId
            });
            if (resValue.code == 200) {
                this.loading = false;
                this.tableList = resValue.data;
            } else {
                this.$refs.box.setWrong(resValue.msg);
            }
        },
        async confirm() {
            this.arr = [];
            this.tableList.forEach(it => {
                this.arr.push(it.value);
            });
            let resValue = await environmentSettings({
                barId: this.barId,
                arr: this.arr.join(",")
            });
            if (resValue.code == 200) {
                this.$refs.box.hide();
                this.successFn();
            } else {
                this.$refs.box.setWrong(resValue.msg);
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import "_style/table/_default.scss";
@import "_style/cssfn/common.scss";
.modal-body {
    padding: 10px 20px;
    text-align: left;
    position: relative;
    .tips {
        border: 1px solid rgba(215, 215, 215, 1);
        background: rgba(251, 251, 251, 1);
        padding: 5px;
        margin-bottom: 15px;
    }
    .table {
        max-height: 500px;
        overflow-y: auto;
        .row {
            width: 100%;
            cursor: pointer;
            @include clearfix();
            &:after {
                content: "";
                top: 0;
                left: 0;
                display: block;
                font-size: 0;
                height: 0;
                width: 0;
                clear: both;
                visibility: hidden;
            }
            > div {
                float: left;
                text-align: left;
                text-overflow: ellipsis;
                height: 50px;
                span {
                    @include ellipsis();
                    max-width: 100%;
                }
                p {
                    @include ellipsis();
                    max-width: 100%;
                }
                a {
                    text-align: left;
                    text-indent: 0px;
                    margin-right: 8px;
                    color: #02a7f0;
                }
                input {
                    width: 194px;
                    height: 23px;
                    border: 1px solid rgba(2, 167, 240, 1);
                    background: #fff;
                    cursor: pointer;
                    padding-left: 5px;
                }
            }
            > div:nth-child(1) {
                text-indent: 10px;
                width: 40%;
                text-align: left;
            }
            > div:nth-child(2) {
                width: 25%;
                text-align: center;
            }
            > div:nth-child(3) {
                width: 30%;
                text-align: left;
            }
            select {
                width: 184px;
                height: 25px;
                border: 1px solid rgba(121, 121, 121, 1);
            }
        }

        .table-header {
            > div {
                height: 30px;
                line-height: 30px;
            }
        }
    }
    .addGroupName {
        input {
            width: 212px;
            height: 32px;
            border: 1px solid rgba(215, 215, 215, 1);
            padding-left: 5px;
            margin-right: 10px;
        }
        position: absolute;
        bottom: -43px;
    }
}
</style>
